export let AccordionPanelCssVars = /*#__PURE__*/function (AccordionPanelCssVars) {
  /**
   * The accordion panel's height.
   * @type {number}
   */
  AccordionPanelCssVars["accordionPanelHeight"] = "--accordion-panel-height";
  /**
   * The accordion panel's width.
   * @type {number}
   */
  AccordionPanelCssVars["accordionPanelWidth"] = "--accordion-panel-width";
  return AccordionPanelCssVars;
}({});